import { compose } from 'redux';
import { mergePersistedState } from 'redux-localstorage';
import isEmpty from 'lodash/isEmpty';
import adapter from 'redux-localstorage/lib/adapters/localStorage';
import filter from 'redux-localstorage-filter';
import debounce from 'redux-localstorage-debounce';
import rootReducer from '../containers/Root/reducer';
import { formName } from '../containers/TechniciansReportForm/constants';

const clearIfEmpty = storage => ({
  ...storage,
  put(key, state, callback) {
    const { form = {} } = state;
    if (isEmpty(form[formName])) {
      return storage.del(key, callback);
    }
    storage.put(key, state, callback);
  }
});

export const reducer = compose(
  mergePersistedState()
)(rootReducer);

export const storage = compose(
  debounce(240, 1000),
  filter([`form.${formName}`, 'technicians.form']),
  clearIfEmpty
)(adapter(window.localStorage));



// WEBPACK FOOTER //
// ./src/store/reducerAndStorage.js